import { AxiosHeaders } from 'axios';
import http from './http';

export const getData = async <T, R, Z = AxiosHeaders>(
  url: string,
  params?: R,
  headers?: Z,
  hideGlobalError?: boolean
): Promise<T> => {
  return http.get(url, {
    params,
    headers: headers as AxiosHeaders,
    hideGlobalError,
  });
};

export const postData = async <T, R, Z = AxiosHeaders>(
  url: string,
  data?: R,
  headers?: Z,
  hideGlobalError?: boolean
): Promise<T> => {
  return http.post(url, data, {
    headers: headers as AxiosHeaders,
    hideGlobalError,
  });
};

export const putData = async <T, R>(
  url: string,
  data?: R,
  hideGlobalError?: boolean
): Promise<T> => {
  return http.put(url, data, { hideGlobalError });
};

export const deleteData = async <T, R>(
  url: string,
  params?: R,
  hideGlobalError?: boolean
): Promise<T> => {
  return http.delete(url, {
    params,
    hideGlobalError,
  });
};

export const patchData = async <T, R>(
  url: string,
  data?: R,
  hideGlobalError?: boolean
): Promise<T> => {
  return http.patch(url, data, { hideGlobalError });
};
